// FAQ
$(function () {
  $(".dropdown .value").on("click", function (event) {
    $(".dropdown").addClass("active");
    event.stopPropagation();
  });

  $(document).on("click", function (event) {
    $(".dropdown").removeClass("active");
  });

  $(".toggle-collapse").on("click", function () {
    let thisGroup = $(this).parents(".group");
    var allCollapsed = thisGroup.find('.collapse:not(".show")').length === 0;

    if (allCollapsed) {
      thisGroup.find(".collapse").collapse("hide");
      thisGroup.removeClass("all-show");
    } else {
      thisGroup.find(".collapse").collapse("show");
      thisGroup.addClass("all-show");
    }
  });

  $(".item").on("shown.bs.collapse hidden.bs.collapse", function () {
    let thisGroup = $(this).parents(".group");
    var allCollapsed = thisGroup.find('.collapse:not(".show")').length === 0;

    if (allCollapsed) {
      thisGroup.addClass("all-show");
    } else {
      thisGroup.removeClass("all-show");
    }
  });
});
